import { Division, KeyValue } from "../../../models";
import { Settings } from "../../../rest/settings";
import { Actions, createNamespace } from "../../../flux/Actions";
import { LanguageOption } from "../../../polyglot/languagePacks";

const ns = createNamespace('SETTINGS');
export const names = {
    SET_DIVISION: ns('SET_DIVISION'),
    SET_SETTINGS_ITEMS: ns('SET_SETTINGS_ITEMS'),
    SET_QUANTITY_UNIT: ns('SET_QUANTITY_UNIT'),
    SET_EMAILS: ns('SET_EMAILS'),

    SET_LANGUAGE: ns('SET_LANGUAGE'),
    SET_LANGUAGE_ITEMS: ns('SET_LANGUAGE_ITEMS'),
    SET_PASSWORD_FLAG: ns('SET_PASSWORD_FLAG'),
    SET_PASSWORD: ns('SET_PASSWORD'),
    SET_PASSWORD_CONFIRMATION: ns('SET_PASSWORD_CONFIRMATION'),

    SET_DONT_ALERT_LEAVING_RED: ns('SET_DONT_ALERT_LEAVING_RED'),
    SET_DONT_ALERT_ENTERING_YELLOW: ns('SET_DONT_ALERT_ENTERING_YELLOW'),
    SET_DONT_ALERT_LEAVING_YELLOW: ns('SET_DONT_ALERT_LEAVING_YELLOW'),
    
    REJECT: ns('REJECT'),
};

// These are actions which settings UI component could emmit in order to change a state
export class SettingsActions extends Actions
{
    setDivision = (division: Division) => this.dispatch(names.SET_DIVISION, division);
    setSettingsItems = (settings: Settings) => this.dispatch(names.SET_SETTINGS_ITEMS, settings);
    setQuantityUnit = (quantityId: number, unitId: number) => this.dispatch(names.SET_QUANTITY_UNIT, { key: quantityId, value: unitId } as KeyValue<number, number>);
    setEmails = (value: string) => this.dispatch(names.SET_EMAILS, value);

    setLanguage = (lang: LanguageOption) => this.dispatch(names.SET_LANGUAGE, lang);
    setLanguageItems = (languages: LanguageOption[]) => this.dispatch(names.SET_LANGUAGE_ITEMS, languages);
    setChangePasswordFlag = (flag: boolean) => this.dispatch(names.SET_PASSWORD_FLAG, flag);
    setPassword = (pwd: string) => this.dispatch(names.SET_PASSWORD, pwd);
    setPasswordConfirmation = (pwd: string) => this.dispatch(names.SET_PASSWORD_CONFIRMATION, pwd);

    setDontAlertLeavingRedZone = (value: boolean) => this.dispatch(names.SET_DONT_ALERT_LEAVING_RED, value);
    setDontAlertEnteringYellowZone = (value: boolean) => this.dispatch(names.SET_DONT_ALERT_ENTERING_YELLOW, value);
    setDontAlertLeavingYellowZone = (value: boolean) => this.dispatch(names.SET_DONT_ALERT_LEAVING_YELLOW, value);
    
    reject = () => this.dispatch(names.REJECT);
}


// WEBPACK FOOTER //
// ./src/app/components/Settings/SettingsActions.ts